angular.module('SpidApp')

.factory('BarcodeScanner', [function () {
  var BarcodeScanner = {
    _barcode: null,

    get: function () {
      return this._barcode
    },

    set: function (barcode) {
      if (!barcode) {
        throw "BarcodeScanner::set() - Missing parameter"
      }

      // WARNING - substr
      this._barcode = barcode
    }
  }

  return BarcodeScanner
}])